import { theme } from '@/theme';

export const styles = {
  loadingScreen: {
    minHeight: '100vh',
    background: theme.colors.bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.primary,
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeight.semibold,
  },
} as const;
